import { TableCell, TableRow, Typography } from "@mui/material";
import { PaginatedTable } from "../../generic/components/paginated-table/paginated-table";

import type { UnfoundConnection } from "../server/supabase-unfound-connections-service";
import type { FC } from "react";

export const UnfoundConnectionsGrid: FC<{
  unfoundConnections: UnfoundConnection[];
}> = ({ unfoundConnections }) => (
  <>
    <Typography variant="h6" sx={{ fontWeight: 600, my: 2 }}>
      Invalid Connection References
    </Typography>
    <PaginatedTable
      data={unfoundConnections}
      config={{
        headers: ["key", "Reference Value", "Source Employee ID", "Source Employee Email"],
      }}
      renderRow={({ connection_reference, key, subject_employee_id, subject_work_email }) => (
        <TableRow data-testid="unfound-connections-grid-row">
          <TableCell>{key}</TableCell>
          <TableCell>{connection_reference}</TableCell>
          <TableCell>{subject_employee_id}</TableCell>
          <TableCell>{subject_work_email}</TableCell>
        </TableRow>
      )}
    />
  </>
);
